export default {
    id: 'MEDCAL_RX_FOOTER_CONTAINER',
        reservedRights: {
        id: 'MEDCAL_RX_RIGHTS_RESERVED',
            defaultMessage: 'All Rights Reserved.',
    },
    privacyPolicy: {
        id: 'MEDCAL_RX_PRIVACY_POLICY',
            defaultMessage: 'Privacy Policy',
            href: "https://www1.magellanrx.com/magellan-rx/mrx-privacy-policy.aspx"
    },
    termsOfUse: {
        id: 'MEDCAL_RX_TERMS_OF_USE',
            defaultMessage: 'Terms of Use',
            href: "https://www1.magellanrx.com/magellan-rx/mrx-terms-of-use.aspx"
    },
    disclaimer: {
        id: 'MEDCAL_RX_DISCLAIMER',
            defaultMessage: 'Disclaimer',
            href: "https://www1.magellanrx.com/magellan-rx/mrx-disclaimer.aspx"
    },
    nondiscrimination: {
        id: 'MEDCAL_RX_NONDISCRIMINATION',
            defaultMessage: 'Nondiscrimination',
            href: "https://www1.magellanrx.com/magellan-rx/nondiscrimination-languages.aspx"
    },
    companyName: {
        id: 'MEDCAL_RX_COMPANY_NAME',
            defaultMessage: 'Magellan Health, Inc.',
            href: 'http://magellanhealth.com'
    },
    opensWindow: {
        id: 'MEDCAL_RX_OPENS_WINDOW',
            defaultMessage: '(opens new window)',
    },
    logo:{
        id: 'MEDCAL_RX_FOOTER_LOGO',
            defaultMessage: "MagellanRx Management Footer Logo",
            href: "http://magellanrx.com"
    },
    year: {
        getYear: (start=1999) => `\u00A9${start} - ${new Date().getFullYear()}`,
            id: 'MEDCAL_RX_FOOTER_YEAR'
    },
    icons:{
        home:{
            text: 'Home',
            to: '/',
            id: 'MEDCAL_RX_NAV_FOOTER_HOME'
        },
        tools:{
            text: 'Tools',
            to: '/tools',
            id: 'MEDCAL_RX_NAV_TOOLS'
        },
        resources:{
            text: 'Resources',
            to: '/resources',
            id: 'MEDCAL_RX_NAV_RESOURCES'
        },
        logout:{
            text: 'Logout',
            to: '',
            id: 'MEDCAL_RX_NAV_LOGOUT'
        },
        twitter:{
            text: 'Twitter',
            to: 'https://twitter.com/magellan_rx',
            id: 'MEDCAL_RX_SOCIAL_TWITTER'
        },
        linkedin:{
            text: 'LinkedIn',
            to: 'https://www.linkedin.com/company/magellan-rx-management',
            id: 'MEDCAL_RX_SOCIAL_LINKEDIN'
        },
        youtube:{
            text: 'Youtube',
            to: 'https://www.youtube.com/channel/UCruVCts2sOwbCj1nG7frnjQ',
            id: 'MEDCAL_RX_SOCIAL_YOUTUBE'
        },
        facebook:{
            text: 'Facebook',
            to: 'https://www.facebook.com/DHCS.CA',
            id: 'MEDCAL_RX_SOCIAL_FACEBOOK'
        }
    },
    langLinks: [
        {
            text: 'العربية',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#arabic'
        },
        {
            text: 'Հայերեն',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#armenian'
        },
        {
            text: 'ខ្មែរ',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#cambodian'
        },
        {
            text: '繁體中文',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#chinese'
        },
        {
            text: 'فارسی',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#farsi'
        },
        {
            text: 'हिन्दी भाषा',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#hindi'
        },
        {
            text: 'Hmoob',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#hmong'
        },
        {
            text: '日本語',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#japanese'
        },
        {
            text: '한국어',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#korean'
        },
        {
            text: 'ລາວ',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#laotian'
        },
        {
            text: 'Mienh waac',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#mienhwaac'
        },
        {
            text: 'ਪੰਜਾਬੀ',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#punjabi'
        },
        {
            text: 'Русский',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#russian'
        },
        {
            text: 'Español',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#spanish'
        },
        {
            text: 'Tagalog',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#tagalog'
        },
        {
            text: 'ภาษาไทย',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#thai'
        },
        {
            text: 'Українська',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#ukrainian'
        },
        {
            text: 'Tiếng Việt',
            to: 'https://www.dhcs.ca.gov/Pages/Language_Access.aspx#vietnamese'
        },
    ],
    footerBottomActions: [
        {
            text: 'Conditions of Use',
            link: 'https://www.dhcs.ca.gov/pages/use.aspx'
        },
        {
            text: 'Privacy Policy',
            link: 'https://www.dhcs.ca.gov/pages/privacy.aspx'
        },
        {
            text: 'Accessibility Certification',
            link: 'https://www.dhcs.ca.gov/Documents/Web-Accessibility-Cert.pdf'
        },
        {
            text: 'Translation Disclaimer',
            action: setModal => setModal(prev => ({...prev, open: true}))
        },
        {
            text: 'Back to Top',
            action: () => window.scroll(0,0)
        },
    ],
    translationDisclaimer: 'The translation tool is provided for purposes of information and convenience only. Google Translate is a free third-party service, which is not controlled by this website'
}
